// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2B2sX","addWidgetButton":"Header_addWidgetButton__1NAw6","dashboardTabs":"Header_dashboardTabs__39HPV","active":"Header_active__th7mN"};